import React from "react";
import { Info, HelpCircle } from "lucide-react";

const Header: React.FC = () => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <p className="page-title">Calendar & Scheduling</p>
        <p className="page-subtitle">
          Configure holidays and working hours for utility operations
        </p>
      </div>
    </div>
  );
};

export default Header;
